import React from 'react';
import { IProps } from './types';
// import moment from 'moment';
import moment from 'moment-timezone';
import _ from 'lodash';
import { EndorseOptContent, EndorseOptContentData } from 'bff/models/member';
import { EndorseColType } from 'constants/enums/endorseColType';
import { Correction_FlightInfo, EndorseOption, FlightScheduleInfo } from 'constants/models/endorseOption';

const PreviewTravel: React.FC<IProps> = (props) => {
    /**
     * @description 建立原始航班資訊
     */
    const handleCreateOriginaFlightInfo = () => {
        if (
            !props.originalEndorse ||
            !props.originalEndorse.OPTION ||
            props.originalEndorse.OPTION.length === 0
        ) return;

        const flightInfo = _.find(props.originalEndorse.OPTION, (opt: EndorseOptContent) => opt.DATA_TYPE === EndorseColType.FLIGHT);
        if (!flightInfo) return;

        return _.map(flightInfo.DATA, (data: EndorseOptContentData, index: number) => {
            return (
                <tr key={index}>
                    <td>{`航班${index + 1}`}</td>
                    <td>{moment(data.FLIGHT_DATE).format("YYYY/MM/DD")}</td>
                    <td>{data.AIRLINE_ID}</td>
                    <td>{data.FLIGHT_NO}</td>
                    <td>
                        <div className="correction-preview__flight-table__flight-container">
                            <label>
                                <div className="correction-preview__flight-table__flight-period">
                                    <div className="correction-preview__flight-table__flight-period-item">
                                        <span>{data.DEPARTURE_AIRPORT}</span>
                                        <span>{moment(data.DEPARTURE_TIME).format("YYYY/MM/DD")}</span>
                                    </div>
                                    <div className="correction-preview__flight-table__flight-period-icon" />
                                    <div className="correction-preview__flight-table__flight-period-item">
                                        <span>{data.ARRIVAL_AIRPORT}</span>
                                        <span>{moment(data.ARRIVAL_TIME).format("YYYY/MM/DD")}</span>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </td>
                </tr>
            )
        })
    }

    /**
     * @description 建立變更後的航班資訊 
     */
    const handleCreateEditFlightInfo = () => {
        if (!props.editedEndorseItems || props.editedEndorseItems.length === 0) return;

        const flightInfo = _.find(props.editedEndorseItems, (item: EndorseOption) => item.DATA_TYPE === EndorseColType.FLIGHT && item.CHECKED);
        if (!flightInfo) return;

        return _.map(flightInfo.FLICHT_INFOS, (info: Correction_FlightInfo, index: number) => {
            return (
                <tr key={index}>
                    <td>{`航班${index + 1}`}</td>
                    <td>{moment(info.FDATE).format("YYYY/MM/DD")}</td>
                    <td>{info.CARRIER_ID}</td>
                    <td>{info.FLIGHT_NO}</td>
                    <td>
                        {
                            info.SEARCH_RESULT && info.SEARCH_RESULT.length > 0 && _.map(info.SEARCH_RESULT, (res: FlightScheduleInfo, searchIndex: number) => {
                                return (
                                    <div className="correction-preview__flight-table__flight-container" key={searchIndex}>
                                        <label>
                                            <div className="correction-preview__flight-table__flight-period">
                                                <div className="correction-preview__flight-table__flight-period-item">
                                                    <span>{res.DEPARTURE_AIRPORT}</span>
                                                    <span>{moment(res.DEPARTURE_TIME).format("YYYY/MM/DD")}</span>
                                                </div>
                                                <div className="correction-preview__flight-table__flight-period-icon" />
                                                <div className="correction-preview__flight-table__flight-period-item">
                                                    <span>{res.ARRIVAL_AIRPORT}</span>
                                                    <span>{moment(res.ARRIVAL_TIME).format("YYYY/MM/DD")}</span>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                )
                            })
                        }
                    </td>
                </tr>
            )
        })
    }

    return (
        <div className="correction-preview__flight-table">
            <table>
                <thead>
                    <tr>
                        <th colSpan={5}>原始航班資訊</th>
                    </tr>
                    <tr>
                        <th />
                        <th>航班日期</th>
                        <th>航班代碼</th>
                        <th>航空編號</th>
                        <th>航班時間及時段</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        handleCreateOriginaFlightInfo()
                    }
                </tbody>
            </table>
            <table>
                <thead>
                    <tr>
                        <th colSpan={5}>批改後航班資訊</th>
                    </tr>
                    <tr>
                        <th />
                        <th>航班日期</th>
                        <th>航班代碼</th>
                        <th>航空編號</th>
                        <th>航班時間及時段</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        handleCreateEditFlightInfo()
                    }
                </tbody>
            </table>
        </div>
    )
}

export default PreviewTravel;